module.exports = __webpack_public_path__ + "img/logo_live.5efa3f21.png";